import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueMeta from "vue-meta";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faFlickr } from "@fortawesome/free-brands-svg-icons";

import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faVolumeUp } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import JQuery from "jquery";

import VueSocialSharing from "vue-social-sharing";
import VueAnalytics from "vue-analytics";
import VueGtag from "vue-gtag";

import VueLodash from "vue-lodash";
import lodash from "lodash";

// SOCKET.IO CLIENT V4
import { io } from "socket.io-client";

library.add(
  faTiktok,
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
  faYoutube,
  faFlickr,
  faEnvelope,
  faUser,
  faGlobe,
  faArrowLeft,
  faChevronRight,
  faDownload,
  faCheck,
  faTimes,
  faPlayCircle,
  faArrowDown,
  faArrowUp,
  faSearch,
  faVolumeUp
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueLodash, {
  name: "custom",
  lodash: lodash
});

Vue.config.productionTip = false;

Vue.use(VueMeta);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueSocialSharing);

// SOCKET CONNECTION
const socket = io("https://ocs-let.com", {
  path: "/tms/let/socket.io",
  transports: ["websocket", "polling"],
});

// OPTIONAL DEBUGGING
socket.on("connect", () => {
  console.log("Socket connected:", socket.id);
});

socket.on("disconnect", () => {
  console.log("Socket disconnected");
});

socket.on("connect_error", (err) => {
  console.error("Socket connection error:", err);
});

// MAKE SOCKET AVAILABLE GLOBALLY
Vue.prototype.$socket = socket;

Vue.use(VueAnalytics, {
  id: "G-SMYF6V944W",
  router
});

Vue.filter("filterByMonth", function(posts, selectedMonth) {
  if (selectedMonth === 0) {
    return posts;
  }

  return posts.filter(post => {
    const postDate = new Date(post.date);
    const postMonth = postDate.getMonth() + 1;

    return postMonth === selectedMonth;
  });
});

Vue.use(
  VueGtag,
  {
    config: {
      id: "G-SMYF6V944W"
    },
    includes: [
      {
        id: "G-SMYF6V944W"
      }
    ]
  },
  router
);

new Vue({
  router,
  store,
  axios,
  JQuery,
  render: h => h(App)
}).$mount("#app");